import Login from 'features/auth/Login';

const LoginPage = ({ hasAccess = true }) => <Login hasAccess={hasAccess} />;

export default LoginPage;
